import { BrowserRouter } from 'react-router-dom';
import Routes from './config/routes';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { setUserAfterLogin } from './store/actions/login';
import { isAuthenticUser } from './utils/helpers/validateuser';
import MfaStepUpModal from './components/auth/MfaStepUpModal';
import FullLoader from './components/common/FullLoader';
import { removeToken } from './utils/security/tokenStorage';

function App() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const restoreSession = async () => {
      try {
        const isStillValid = await isAuthenticUser();
        if (isStillValid) {
          dispatch(setUserAfterLogin());
        }
      } catch (error) {
        console.error('Session restore failed', error);
        removeToken();
      } finally {
        setIsLoading(false);
      }
    };

    restoreSession();
  }, [dispatch]);

  if (isLoading) {
    return <FullLoader />;
  }

  return (
    <BrowserRouter>
      <MfaStepUpModal />
      <Routes />
    </BrowserRouter>
  );
}

export default App;
